module.exports = __webpack_public_path__ + "static/caroline-mutoko-c8d72cae764d0d85cb56c816e954c048.jpg";